import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { EmptyFilter, Filter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { POStatus } from "../../models/PurchaseOrder";
import { POStatusMap } from "../../models/FDropdown";

interface IIncentiveList {
    id?: number,
    login_ID?: number,
    user_Name?: string,
    company_ID?: number,
    company_Name?: string,
    branch_ID?: number,
    branchName?: string,
    release_Date?: Date,
    actual_Incentive_Amount?: number,
    tds_Deduction_Amount?: number,
    attendace?: number
}

interface IProps {
    toast: any
}

export const ReleasedIncentiveList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IIncentiveList[], loading: boolean });
    const [tableData2, setTableData2] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [incentiveFilter, setIncentiveFilter] = useState(EmptyFilter);
    const [modal, setModal] = useState({ singleData: {}, open: false } as { singleData: IIncentiveList, open: boolean });
    const dt = useRef<any>();
    const dt2 = useRef<any>();

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch(`InvoiceTracking/${"allReleasedIncentiveList"}`, "GET", null, `filter=${encodeURIComponent(JSON.stringify(incentiveFilter))}`, null);
        if (response) {
            const data: IIncentiveList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    };

    const loadTableDataByReleasedIncentiveID = async () => {
        setTableData2({ tableData: tableData2.tableData, loading: true });
        const response = await Fetch(`InvoiceTracking/allReleasedIncentivesListByGeneratedID`, "GET", null, `filter=${modal?.singleData?.id}`, null);
        if (response) {
            const data: any[] = await response.json();
            setTableData2({ tableData: data, loading: false });
        } else {
            setTableData2({ tableData: tableData2.tableData, loading: false });
        }
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const exportCSV2 = () => {
        dt2.current.exportCSV();
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const totalIncentive = (rowData: IIncentiveList) => {
        return (
            <>
                <div className="flex justify-content-between gap-3">
                    <p className="cursor-pointer text-cyan-700 underline" onClick={() => setModal({ singleData: rowData, open: true })}>₹ {rowData.actual_Incentive_Amount}</p>
                </div>
            </>
        )
    };

    const onHde = () => {
        setModal({ singleData: {}, open: false });
        setTableData2({ tableData: [], loading: false });
    };

    useEffect(() => {
        if (modal.open && modal.singleData.id) {
            loadTableDataByReleasedIncentiveID();
        }
    }, [modal.open]);

    useEffect(() => {
        loadTableData();
    }, [incentiveFilter]);

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter incentiveFilter={incentiveFilter} setIncentiveFilter={(incentiveFilter: any) => setIncentiveFilter(incentiveFilter)} toast={props.toast} isReleased={true} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines
                value={tableData.tableData} lazy dataKey="id"
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={<p>Released Incentive</p>}
                loading={tableData.loading}
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Name" />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="release_Date" header="Month Year" body={(rowData: any) => {
                    const [year, month] = rowData.release_Date.split("T")[0].split("-");
                    const date = new Date(year, month - 1); // month is 0-based
                    const options: any = { year: 'numeric', month: 'long' };
                    const formatted = date.toLocaleString('en-US', options);

                    return <p>{formatted}</p>;
                }} />
                <Column field="actual_Incentive_Amount" header="Total Incentive" body={totalIncentive} />
                <Column field="attendace" header={`Present Days In ${(Number(new Date(incentiveFilter.month || "").toISOString().split('T')[0].split("-")[1]) - 1) < 10 ? `0${Number(new Date(incentiveFilter.month || "").toISOString().split('T')[0].split("-")[1]) - 1}` : Number(new Date(incentiveFilter.month || "").toISOString().split('T')[0].split("-")[1]) - 1}-${new Date(incentiveFilter.month || "").toISOString().split('T')[0].split("-")[0]}`} body={(rowData: any) => <p>{rowData.attendace}</p>} />
                <Column field="tds_Deduction_Amount" header="TDS Deduction" body={(rowData: any) => <p>₹ {rowData.tds_Deduction_Amount || 0}</p>} />
                <Column field="actual_Incentive" header="Actual Incentive" body={(rowData: any) => <p>₹ {(Number(rowData.actual_Incentive_Amount || "0") - Number(rowData.tds_Deduction_Amount || "0")).toFixed(2)}</p>} />
                <Column field="createdBy" header="Created By" />
            </DataTable>
            <Dialog visible={modal.open} style={{ width: '80vw' }} header={<p style={{ color: "#2196F3", fontWeight: "bolder" }}>Released Incentive PO Wise</p>} className="p-fluid" onHide={onHde} draggable={true}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt2} size="small" stripedRows showGridlines
                    lazy dataKey="user_ID"
                    value={tableData2.tableData}
                    emptyMessage="No Users found."
                    header={<div className="flex w-full align-content-center justify-content-between"><p>Released Incentive</p><Button label="Export" icon="pi pi-upload" className="p-button-help" style={{ width: "7rem" }} onClick={exportCSV2} /></div>}
                // loading={tableData.loading}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_Id" header="Req ID" />
                    <Column field="consultant_Name" header="Consultant Name" />
                    <Column field="fromDate" header="From Date" />
                    <Column field="toDate" header="To Date" />
                    <Column field="invoiceHours" header="Hours" />
                    <Column field="bRate" header="Buying Rate" />
                    <Column field="sRate" header="Submittal Rate" />
                    <Column field="mRate" header="Margin" />
                    <Column field="incPer" header="IncPer %" />
                    <Column field="receivedAmount" header="Amount" />
                    <Column field="dollerRate" header="Dollar Rate" />
                    <Column field="converted_Amount" header="Converted Amount" />
                    <Column field="salesmanager" header="Salesmanager" />
                    <Column field="sales_Comp_Branch" header="sales Company Branch" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="recruiter_Comp_Branch" header="Recruiter Company Branch" />
                    <Column field="project_Start_Date" header="Project Start Date" />
                    <Column field="project_End_Date" header="Project End Date" />
                    <Column field="pO_Status" header="PO Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
                </DataTable>
            </Dialog>
        </>
    );
}